import {
  BasePayloadMapper,
  Nullable,
  omitNullValues,
  Undefinable,
} from '@ps/utils';
import { SURVEY_STATUS } from '@ps/survey-kernel';
import { SurveyLookupParams } from '@ps/survey-utils';
import { SurveyLookupParamsDto } from '../dtos/survey-lookup.dto';

const LOOKUP_STATUS = [SURVEY_STATUS.CLOSED, SURVEY_STATUS.INVOICED];

export class SurveyLookupPayloadMapper extends BasePayloadMapper<
  SurveyLookupParams,
  SurveyLookupParamsDto
> {
  public toPayload(params: SurveyLookupParams): SurveyLookupParamsDto {
    return {
      fromDate: params.fromDate ? this._formatDate(params.fromDate) : '',
      toDate: params.toDate ? this._formatDate(params.toDate) : '',
      status: LOOKUP_STATUS.join(','),
      ...omitNullValues({
        searchKey: this._pairedValue(params.searchKey, params.searchValue),
        searchValue: this._pairedValue(params.searchValue, params.searchKey),
        incl_excl: params.inclExcl,
        billingNumbers: this._joinedIds(params.billingNumbers),
        templateIds: this._joinedIds(params.templateIds),
        projectManagerIds: this._joinedIds(params.projectManagerIds),
        surveyIds: this._joinedIds(params.surveyIds),
        countryCode: this._pairedValue(params.countryCode, params.languageCode),
        languageCode: this._pairedValue(
          params.languageCode,
          params.countryCode,
        ),
      }),
    };
  }

  // Wire format is `YYYYMMDD`, no separators (e.g. `20260804` for 2026-08-04) — confirmed
  // against legacy's `CommonService.formatDate`, not ISO-8601. Uses local date parts, matching
  // legacy's `Date.getFullYear/getMonth/getDate`, not UTC — a date picked as "Aug 4" must stay
  // "Aug 4" here regardless of the browser's timezone offset from UTC.
  private _formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = `${date.getMonth() + 1}`.padStart(2, '0');
    const day = `${date.getDate()}`.padStart(2, '0');

    return `${year}${month}${day}`;
  }

  private _pairedValue(
    value: Undefinable<string>,
    pairedWith: Undefinable<string>,
  ): Nullable<string> {
    return value && pairedWith ? value : null;
  }

  private _joinedIds(
    ids: Undefinable<Array<string | number>>,
  ): Nullable<string> {
    return ids?.length ? ids.join(',') : null;
  }
}
